import { Text } from "@chakra-ui/react";

export default function Body({ children, ...rest }) {
  return (
    <Text fontSize="1.4rem" letterSpacing="0.3px" lineHeight="1.71" {...rest}>
      {children}
    </Text>
  );
}
